import Vue from 'vue'
import App from './App.vue'
import router from './router'
import jquery from 'jquery'
import {Configs} from './scripts/configs.js'
import * as VueGoogleMaps from 'vue2-google-maps'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.prototype.$configs = Configs
Vue.prototype.$jq = jquery
Vue.use(VueGoogleMaps, {
  load: {
    key: Configs.gmap_apikey
  },
  installComponents: true,
});


new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
